import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import InstarVisionMenuCards01 from 'components/Software/macOS/InstarVision/Advanced/instarVisionMenuCards01';
import InstarVisionMenuCards02 from 'components/Software/macOS/InstarVision/Advanced/instarVisionMenuCards02';
import NavButtons from 'components/Software/macOS/InstarVision/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "InstarVision v3 für macOS",
  "path": "/Software/macOS/InstarVision/Advanced/",
  "dateChanged": "2018-01-25",
  "author": "Mike Polinowski",
  "excerpt": "Das InstarVision Surveillance Center bietet Ihnen eine Vielzahl von Optionen zur Aufzeichnung von Ereignissen - Programmieren einer geplanten Videoaufnahme, Auslösen von Videoaufzeichnungen, FTP-Uploads und E-Mail-Benachrichtigungen durch Bewegungserkennung oder die Verwendung der Software zum Erstellen einer Reihe von Fotos, die später zu einem Timelapse-Video.",
  "image": "../P_SearchThumb_InstarVision_Windows.png",
  "social": "/images/Search/P_SearchThumb_InstarVision_Windows.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-Windows-InstarVision_white.webp",
  "chapter": "Software"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEOHelmet title='InstarVision v3 für macOS' dateChanged='2018-01-25' author='Mike Polinowski' tag='INSTAR IP Camera' description='Das InstarVision Surveillance Center ist eine IP-Kamera-Software, die 64 Kameras gleichzeitig unterstützen kann, einschließlich Netzwerkkameras, USB-Kameras mit Fernzugriff und Sekundärinstallationen der Software.' image='/images/Search/P_SearchThumb_InstarVision_Windows.png' twitter='/images/Search/P_SearchThumb_InstarVision_Windows.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Software/macOS/InstarVision/Advanced/' locationFR='/fr/Software/macOS/InstarVision/Advanced/' crumbLabel="Advanced" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <p><img parentName="p" {...{
        "src": "./Banner_en-InstarVision2-0_Advanced.png",
        "alt": "InstarVision v3 for Windows"
      }}></img></p>
    <h2 {...{
      "id": "erweitert",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#erweitert",
        "aria-label": "erweitert permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Erweitert`}</h2>
    <p><strong parentName="p">{`Das Erweitert Menü gibt Ihnen Zugriff zu einer Reihe von Werkzeugen, die über den alltäglichen Einsatz des Sicherheit Centers hinausgehen.`}</strong></p>
    <p>{`Überprüfen Sie das System Log auf Unregelmäßigkeit, exportieren Sie Ihre Systemeinstellungen um diese später - z.B. nach einem System Crash - wieder problemlos einspielen zu können, öffnen Sie das Aufnahmeverzeichnis der Software im Windows Explorer um Zugriff auf die Video Dateien zu bekommen.`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <InstarVisionMenuCards01 mdxType="InstarVisionMenuCards01" />
    <EuiSpacer mdxType="EuiSpacer" />
    <InstarVisionMenuCards02 mdxType="InstarVisionMenuCards02" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      